import React from 'react';
import { RefreshCw, Download, X } from 'lucide-react';
import { useAppearance } from '../contexts/AppearanceContext';

const UpdatePrompt = ({ isVisible, onUpdate, onDismiss, version }) => {
  const { isSuppleMode, appearanceMode } = useAppearance();

  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-[9999] flex items-center justify-center p-4">
      <div className={`max-w-md w-full rounded-lg p-6 shadow-2xl appearance-${appearanceMode} ${
        isSuppleMode 
          ? 'supple-card-glass supple-border-subtle backdrop-blur-xl border' 
          : 'bg-white border border-gray-200'
      }`}>
        <div className="flex items-center gap-3 mb-4">
          <div className={`w-12 h-12 rounded-full flex items-center justify-center ${
            isSuppleMode 
              ? 'supple-btn-gradient-blue' 
              : 'bg-blue-600'
          }`}>
            <Download className="w-6 h-6 text-white" />
          </div>
          <div>
            <h3 className={`text-lg font-semibold ${
              isSuppleMode ? 'supple-text-primary' : 'text-gray-900'
            }`}>
              New Version Available
            </h3>
            {version && (
              <p className={`text-sm ${
                isSuppleMode ? 'supple-text-muted' : 'text-gray-600'
              }`}>
                Version {version} is ready
              </p>
            )}
          </div>
          <button
            onClick={onDismiss}
            className={`ml-auto p-2 rounded-lg transition-colors ${
              isSuppleMode 
                ? 'hover:supple-card-glass-hover supple-text-muted' 
                : 'hover:bg-gray-100 text-gray-500'
            }`}
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        <p className={`text-sm mb-6 ${
          isSuppleMode ? 'supple-text-secondary' : 'text-gray-700'
        }`}>
          A new version of Supple Chat is available with improvements and bug fixes. 
          Update now to get the latest features.
        </p>

        <div className="flex gap-3">
          <button
            onClick={onUpdate}
            className={`flex-1 flex items-center justify-center gap-2 px-4 py-3 rounded-lg font-medium transition-all ${
              isSuppleMode 
                ? 'supple-btn-gradient-blue hover:supple-btn-gradient-blue-hover supple-shadow-md' 
                : 'bg-blue-600 text-white hover:bg-blue-700'
            }`}
          >
            <RefreshCw className="w-4 h-4" />
            Update Now
          </button>
          
          <button
            onClick={onDismiss}
            className={`px-4 py-3 rounded-lg font-medium transition-colors ${
              isSuppleMode 
                ? 'supple-text-primary hover:supple-card-glass-hover' 
                : 'text-gray-700 hover:bg-gray-100'
            }`}
          >
            Later
          </button>
        </div>

        <div className={`mt-4 text-xs text-center ${
          isSuppleMode ? 'supple-text-muted' : 'text-gray-500'
        }`}>
          The app will automatically restart after updating
        </div>
      </div>
    </div>
  );
};

export default UpdatePrompt;